module.exports = __webpack_public_path__ + "img/Retail22.a76e42c4.png";